import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useSongStoreSelector } from '../hooks/useSongStoreSelector';

interface StoreHydrationGateProps {
  children: React.ReactNode;
}

export const StoreHydrationGate: React.FC<StoreHydrationGateProps> = ({ children }) => {
  const { hasLoadedInitial } = useSongStoreSelector();

  if (!hasLoadedInitial) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return <>{children}</>;
};